<template>
  <div>
    <Loading :active="is_loading" :can-cancel="false" :is-full-page="true" />

    <b-modal :active="show" @update:active="closeModal">
      <div v-if="!is_loading" class="card">
        <div class="card-header">
          <div class="card-header-title">Filer</div>
        </div>
        <div class="card-content">
          <nav class="panel">
            <p class="panel-heading">
              Filer ejet af eller delt med dig
            </p>
            <p class="panel-tabs">
              <a
                @click="panelScope = 'scope_all'"
                :class="{ 'is-active': activePanel('scope_all') }"
                >Alle filer</a
              >
              <a
                @click="panelScope = 'scope_project'"
                :class="{ 'is-active': activePanel('scope_project') }"
                >Vedr. projekt</a
              >
              <a
                @click="panelScope = 'scope_share'"
                :class="{ 'is-active': activePanel('scope_share') }"
                >Delt med dig</a
              >
            </p>
            <a v-for="(file, index) in tabData" :key="index" class="panel-block"
              >{{ file.original_filename }}: {{ file.id }}</a
            >
            <label class="panel-block">
              <input type="checkbox" />
              remember me
            </label>
            <div class="panel-block">
              <button class="button is-link is-outlined is-fullwidth">
                Reset all filters
              </button>
            </div>
          </nav>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import FileTag from '@/infrastructure/fileuploads/components/FileTag'
import { mapGetters } from 'vuex'

export default {
  name: 'FileModal',
  components: {
    Loading,
    FileTag
  },
  props: ['show', 'active_panel'],
  data () {
    return {
      is_loading: true,
      panelScope: null,
    }
  },
  computed: {
    ...mapGetters('fileuploads', ['allFiles', 'projectFiles', 'shareFiles']),
    tabData () {
      switch (this.panelScope) {
        case 'scope_all':
          return this.allFiles
        case 'scope_project':
          return this.projectFiles
        case 'scope_share':
          return this.shareFiles
        default:
          return []
      }
    }
  },
  methods: {
    closeModal () {
      this.$emit('CLOSEMODAL')
    },
    activePanel (panelScope) {
      if (this.active_panel === undefined && panelScope === 'scope_all') {
        return true
      }

      if (panelScope === this.panelScope) {
        return true
      }

      return false
    }
  },
  mounted () {
    if (this.panelScope === null) {
      this.panelScope =
        this.active_panel === undefined ? 'scope_all' : this.active_panel
    }

    this.is_loading = true
  }
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/infrastructure/fileuploads/components/FileModal.vue